import { store } from "@/store/store"
import { displayGroupAtom, isCalibrationAtom } from "@/store/project/projects-state"
import { resetAllFilters, openFocusView, openGridView } from "@/store/photo/photos-view-state"
import { createAIStyleFromEdits, getDefaultStyleName } from "@/store/style/create-style"
import {
	anchorPhotosAtom,
	currentPhotoAtom,
	isExpressSetupAtom,
	selectedPhotosIDsAtom,
} from "../photo/photos-state"
import { updateAIStyle } from "./update-style"
import { markOnboardingShown, resetOnboardingShown } from "../app-state"
import { ConfirmDialog, ImageStyle } from "@/components/Dialogs/ConfirmDialog"
import { replaceDialog } from "../dialogs-state"
import { currentStyleAtom } from "./style-state"
import { queueApplyAutoAdjustments } from "@/store/processing/image-processing"
import { applyAIAdjustmentsAtom } from "../settings-state"
import stylePngUrl from "@assets/style.png?url"
import { StyleInfoRecord } from "@/lib/catalog"
import { closeSession } from "@/routing/project-session"
// eslint-disable-next-line no-restricted-imports -- Phase 1: store-layer i18n
import i18n from "@/i18n"

export function startCalibration() {
	resetOnboardingShown("createStyleShown")
	store.set(isCalibrationAtom, true)

	const anchorPhotos = store.get(anchorPhotosAtom)
	const photo = anchorPhotos[0]

	if (photo) {
		store.set(currentPhotoAtom, photo)
		store.set(selectedPhotosIDsAtom, new Set([photo.id]))
	}

	openFocusView()

	const isExpressSetup = store.get(isExpressSetupAtom)
	if (!isExpressSetup) {
		store.set(displayGroupAtom, "suggested")
	}

	// Batch apply auto adjustments to all anchor photos automatically
	if (store.get(applyAIAdjustmentsAtom)) {
		for (const anchorPhoto of anchorPhotos) {
			if (anchorPhoto.historyIndex == null)
				// photo has no adjustments history
				queueApplyAutoAdjustments(anchorPhoto)
		}
	}

	if (store.get(currentStyleAtom) == null) {
		replaceDialog(ConfirmDialog, {
			imageSource: stylePngUrl,
			imageStyle: "fit" as ImageStyle,
			title: isExpressSetup
				? i18n.t("store:calibration.createReferenceEditTitle")
				: i18n.t("store:calibration.createReferenceEditTitleSetup"),
			message: isExpressSetup
				? i18n.t("store:calibration.createReferenceEditExpressMessage")
				: i18n.t("store:calibration.createReferenceEditStandardMessage"),
			primary: {
				title: i18n.t("common:action.continue"),
				handler: () => {
					markOnboardingShown("createStyleShown")
				},
			},
			trackingViewName: "onboarding_create_style",
		})
	}
}

export async function cancelCalibration() {
	await closeSession({ reason: "calibration_cancelled" })
}

export function endCalibration() {
	resetAllFilters()
	const currentStyle = store.get(currentStyleAtom)
	if (currentStyle) {
		endCalibrationAndUpdateProfile(currentStyle)
	} else {
		const styleName = getDefaultStyleName()
		endCalibrationAndCreateProfile(styleName)
	}
}

export async function endCalibrationAndCreateProfile(styleName: string) {
	if (!store.get(isExpressSetupAtom)) {
		openGridView()
	}
	store.set(isCalibrationAtom, false)
	await createAIStyleFromEdits(styleName)
}

export async function endCalibrationAndUpdateProfile(style: StyleInfoRecord) {
	store.set(isCalibrationAtom, false)
	openGridView()
	await updateAIStyle(style, "finish_ai_style_setup")
}
